import moment from 'moment';
import newhttp from '~/http/new';
import storeUtils from '~/utils/storeUtils';

export default ({
  state: {
    data: [],
    filterList: {},
    page: 1,
    pages: 0,
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const { filterList, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];

      const filteredFilters = storeUtils.clearEmptyParams(filterList);

      return {
        ...filteredFilters,
        fromDate: filteredFilters.fromDate ? moment.utc(filteredFilters.fromDate).unix() : undefined,
        toDate: filteredFilters.toDate ? moment.utc(filteredFilters.toDate).set({ hour: 23, minute: 59, second: 59 }).unix() : undefined,
        status: filteredFilters.status !== 3 ? filteredFilters.status : undefined,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filterList = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await newhttp.get('v1/p2p/auto-close-callbacks', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      const { items, total } = response.data;
      commit('SET_DATA', items);
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },
  },

  namespaced: true,
});
